import React, { useRef } from 'react'

import { OverlayPanel } from 'primereact/overlaypanel'
import { Button } from '../../../helpers'


const Expiry = (props) => {
    const { sellerReq, sellerReqItem, setDisabled,handleExpiryClick, setSellerReqs, setInitialSellerReqs, sellerReqsData, setFormErrors, label, materialMandatoryUseFromStock, buyerReq, PMBranches, companyWarehousesData, sellerDetails, relatedVendorRateContractItem } = props
    const op = useRef(null);

    const handleExpiry = (e, type, sellerReqItem, sellerReq) => {
        if (sellerReq?.companyId === sellerReq?.pmCompanyId){
            handleExpiryClick("refresh", sellerReqItem, sellerReq)
        }else{
            handleExpiryClick(type, sellerReqItem, sellerReq)
        }
        op.current.toggle(e)
        setFormErrors({})
        if (type === "expiry"){
            let updatedSellerReqs = sellerReqsData?.map(eachSellerReq => {
                if (eachSellerReq?.sellerReqId === sellerReq.sellerReqId){
                    return {...eachSellerReq, disabled : true}
                }
                return eachSellerReq
            })
            setSellerReqs(updatedSellerReqs)
            setInitialSellerReqs(updatedSellerReqs)
        }
        let updatedSellerReqs = sellerReqsData?.map(eachSellerReq => {
            if (eachSellerReq?.sellerReqId === sellerReq.sellerReqId){
                return {...eachSellerReq, disabled : false}
            }
            return eachSellerReq
        })
        setSellerReqs(updatedSellerReqs)
        setInitialSellerReqs(updatedSellerReqs)
    }

    let useFromStockExpiryDisableCond = false
    if (sellerReq.companyId === sellerReq.pmCompanyId) {
        const relatedMaterialMandatoryUseFromStock = materialMandatoryUseFromStock.find(eachMandatoryMaterial => eachMandatoryMaterial.materialId === sellerReqItem.materialId)
        if (relatedMaterialMandatoryUseFromStock) {
            if(relatedMaterialMandatoryUseFromStock.useFromStockTypeId === 1){
                useFromStockExpiryDisableCond = true
            }
            else if(relatedMaterialMandatoryUseFromStock.useFromStockTypeId === 2){
                if(buyerReq.pmBranchId === sellerReq.branchId){
                    useFromStockExpiryDisableCond = true
                }
            }
            else if(relatedMaterialMandatoryUseFromStock.useFromStockTypeId === 3){
                const relatedPMBranch = PMBranches.find(eachBranch => eachBranch.branchId === sellerReq.pmBranchId)
                const relatedBranchCompanyWarehouse = companyWarehousesData.find(eachCompnayWarehouse => eachCompnayWarehouse.warehouseId === relatedPMBranch.warehouseId)
                const relatedCompanyWarehouse = companyWarehousesData.find(eachCompnayWarehouse => eachCompnayWarehouse.shipAddrId === sellerReqItem.shipAddrId)
                const nearestWarehouses = relatedBranchCompanyWarehouse.nearestWarehouses ? relatedBranchCompanyWarehouse.nearestWarehouses : []

                if(buyerReq.pmBranchId === sellerReq.branchId || nearestWarehouses.includes(relatedCompanyWarehouse.shipAddrId)){
                    useFromStockExpiryDisableCond = true
                }
            }
        }
    }

    const markExpiryDisableCond = !sellerReqItem?.canEditExpiredAndLogistics || useFromStockExpiryDisableCond || relatedVendorRateContractItem
    let markExpiryTooltipText = ''
    if(useFromStockExpiryDisableCond){
        markExpiryTooltipText = 'This material is configured to use from stock!'
    }
    else if(relatedVendorRateContractItem){
        markExpiryTooltipText = `Can't expire vendor rate contract seller req's!`
    }

    return (
        <>
            <div className="flex align-items-center">
                {
                    label === "Mark Expired" ? 
                        (
                            <Button className="small-btn" label={label} outlined severity="danger" onClick={(e) => op.current.toggle(e)} disabled={markExpiryDisableCond} tooltip={markExpiryTooltipText} tooltipOptions={{ position: 'top', showOnDisabled: true }} />
                        ) : 
                        (
                            // <Button className="small-btn" label={label} severity="danger" text />
                            <div className="" style={{ color: "red"}}>{label}</div>
                        )
                }
            </div>
            <OverlayPanel ref={op} className="overlay-panel p-2 mt-3" style={{ minHeight: "6rem"}}>
                <div style={{display:"flex", flexDirection:"column", justifyContent:"space-between"}}>
                    <Button className="small-btn mb-1" label="Mark As Expired" text onClick={e => handleExpiry(e,"expiry", sellerReqItem, sellerReq)}/>
                    <Button className="small-btn mb-1" label="Re-Enter The Quotation" text  onClick={e => handleExpiry(e,"refresh", sellerReqItem, sellerReq)}/>
                    <Button className="small-btn mb-1" label="Cancel" text onClick={e => op.current.toggle(e)}/>
                </div>
            </OverlayPanel>
        </>
    )
}

export default Expiry